// source: https://github.com/apexcharts/apexcharts.js/blob/main/src/utils/Utils.js

/*
 ** Generic functions which are not dependent on ApexCharts
 */

class ApexUtils {
  static isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item) && item != null;
  }

  // Type checking that works across different window objects
  static is(type, val) {
    return Object.prototype.toString.call(val) === `[object ${type}]`;
  }

  // to extend defaults with user options
  // credit: http://stackoverflow.com/questions/27936772/deep-object-merging-in-es6-es7#answer-34749873
  static extend(target, source) {
    if (typeof Object.assign !== 'function') {
      (function () {
        Object.assign = function (target) {
          'use strict';
          // We must check against these specific cases.
          if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
          }

          const output = Object(target);
          for (let index = 1; index < arguments.length; index++) {
            const source = arguments[index];
            if (source !== undefined && source !== null) {
              for (const nextKey in source) {
                if (Object.prototype.hasOwnProperty.call(source, nextKey)) {
                  output[nextKey] = source[nextKey];
                }
              }
            }
          }
          return output;
        };
      })();
    }

    const output = Object.assign({}, target);
    if (this.isObject(target) && this.isObject(source)) {
      Object.keys(source).forEach(key => {
        if (this.isObject(source[key])) {
          if (!(key in target)) {
            Object.assign(output, {
              [key]: source[key],
            });
          } else {
            output[key] = this.extend(target[key], source[key]);
          }
        } else {
          Object.assign(output, {
            [key]: source[key],
          });
        }
      });
    }
    return output;
  }

  static extendArray(arrToExtend, resultArr) {
    const extendedArr = [];
    arrToExtend.map(item => {
      extendedArr.push(ApexUtils.extend(resultArr, item));
    });
    arrToExtend = extendedArr;
    return arrToExtend;
  }

  static clone(source) {
    if (ApexUtils.is('Array', source)) {
      const cloneResult = [];
      for (let i = 0; i < source.length; i++) {
        cloneResult[i] = this.clone(source[i]);
      }
      return cloneResult;
    } else if (ApexUtils.is('Null', source)) {
      // fixes an issue where null values were converted to {}
      return null;
    } else if (ApexUtils.is('Date', source)) {
      return source;
    } else if (typeof source === 'object') {
      const cloneResult = {};
      for (const prop in source) {
        if (Object.prototype.hasOwnProperty.call(source, prop)) {
          cloneResult[prop] = this.clone(source[prop]);
        }
      }
      return cloneResult;
    } else {
      return source;
    }
  }

  // If month counter exceeds 12, it starts again from 1
  static monthMod(month) {
    return month % 12;
  }

  static isNumber(value) {
    return !isNaN(value) && parseFloat(Number(value)) === value && !isNaN(parseInt(value, 10));
  }
}

export default ApexUtils;
